export default function FeaturedProducts() {
  return (
    <section className="featured-products">
      <div className="container">

        <div className="section-header">
          <h2>Featured Products</h2>
          <p>Discover our most popular natural healthcare solutions</p>
        </div>

        <div className="product-grid">

          <div className="product-card">
            <div className="product-image">
              <img src="/assets/products/anti_psoriasis.webp" alt="Anti Psoriasis Cream" />
            </div>
            <div className="product-info">
              <div className="product-category">SKIN CARE</div>
              <h3 className="product-name">Anti Psoriasis Cream</h3>
              <p className="product-description">A natural solution for soothing psoriasis.</p>
              <a href="product/jojoba-r-anti-psoriasis-cream" className="product-link">Learn More</a>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">
              <img src="/assets/products/vitamin_d3.webp" alt="Vitamin D3" />
            </div>
            <div className="product-info">
              <div className="product-category">Nutraceuticals</div>
              <h3 className="product-name">Vitamin D3 Tablet</h3>
              <p className="product-description">Enhance your body's natural defenses.</p>
              <a href="/product/rvibes-vitamin-d3-tablet" className="product-link">Learn More</a>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">
              <img src="/assets/products/liver_care.jpg" alt="Liver Care Tab" />
            </div>
            <div className="product-info">
              <div className="product-category">Herbals</div>
              <h3 className="product-name">Liver Care Tablet</h3>
              <p className="product-description">Calming herbal formula for gut health.</p>
              <a href="product/liver-care-tablet" className="product-link">Learn More</a>
            </div>
          </div>

          <div className="product-card">
            <div className="product-image">
              <img src="/assets/products/rejuvenating_facewash.webp" alt="Rejuvenating Face Wash" />
            </div>
            <div className="product-info">
              <div className="product-category">Cosmetics</div>
              <h3 className="product-name">Rejuvenating Face Wash</h3>
              <p className="product-description">Vitamin-rich wash for glowing skin.</p>
              <a href="product/jojoba-r-rejuvenating-face-wash" className="product-link">Learn More</a>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
